import { AddRounded } from "@mui/icons-material";
import { Button } from "@mui/material";
import { memo, useCallback } from "react";
import { useDispatch } from "react-redux";
import { loanDrilldownSidebarTypes } from "../../../constants/enums/loanDrilldownScreenSidebarOptions";
import {
  sidebarSetParamsValue,
  sidebarSetStateValue,
  sidebarTypeSet,
} from "../../../redux/actions/sidebarActions";

const LoanDrilldownButtonAddEscrowItem = memo(
  ({ size = "small", sx, subjectPropertyId }) => {
    const dispatch = useDispatch();

    const onAdd = useCallback(() => {
      dispatch(sidebarTypeSet(loanDrilldownSidebarTypes.ADD_LOAN_ESCROW_ITEM));
      dispatch(sidebarSetStateValue(null));
      if (subjectPropertyId) {
        dispatch(sidebarSetParamsValue({ subjectPropertyId }));
      } else {
        dispatch(sidebarSetParamsValue(null));
      }
    }, [dispatch, subjectPropertyId]);

    return (
      <Button size={size} sx={sx} startIcon={<AddRounded />} onClick={onAdd}>
        Add Escrow Item
      </Button>
    );
  }
);
export default LoanDrilldownButtonAddEscrowItem;
